//export const API_ENDPOINT = 'http://localhost:30080'
export const API_ENDPOINT = 'https://api.diffsona.com'
export const CDN_TRAIN_ENDPOINT = 'https://cdntrain.diffsona.com'
export const CDN_CONTENT_ENDPOINT = 'https://cdn.diffsona.com'
export const CDN_POSTS_ENDPOINT = 'https://posts.diffsona.com'
